import { Component, Input, OnInit } from '@angular/core';
import { SpinnerSize } from '../../common';

@Component({
  standalone: true,
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent implements OnInit {
  @Input() size: SpinnerSize = SpinnerSize.NORMAL;

  // Enums
  SpinnerSize = SpinnerSize;

  constructor() {}

  ngOnInit() {}
}
